(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_tabs"] && !Shopify.designMode) return;
  try {
    
function reloadTrustpilotWidget(container) {
  if (!container) return;
  const tp = container.querySelector('.trustpilot-widget');
  if (!tp) return;
  const load = () => {
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      window.Trustpilot.loadFromElement(tp, true);
      return true;
    }
    return false;
  };
  if (!load()) {
    const tpScript = document.querySelector('script[src*="tp.widget.bootstrap.min.js"]');
    if (tpScript) {
      tpScript.addEventListener('load', load, { once: true });
    }
    let retries = 0;
    const timer = setInterval(() => {
      retries++;
      if (load() || retries > 20) clearInterval(timer);
    }, 250);
  }
}

function initCustomTabs() {
  // Desktop Tabs
  if (!window.matchMedia('(max-width: 767px)').matches) {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');
    const custom__tabs_detail = document.getElementById("custom__tabs_detail");
    const gotodescription = document.getElementById("goto-description");
    const custom__tabs_trustpilot = document.getElementById("custom__tabs_trustpilot");
    const trustpilot = document.getElementById("trustpilot");

    if (trustpilot && !trustpilot.dataset.bound) {
      trustpilot.dataset.bound = 'true';
      trustpilot.addEventListener('click', function(){
        if (custom__tabs_trustpilot) custom__tabs_trustpilot.click();
        if (custom__tabs_trustpilot) {
          const elementPosition = custom__tabs_trustpilot.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - 160,
            behavior: 'smooth'
          });
        }
      });
    }

    if (gotodescription && !gotodescription.dataset.bound) {
      gotodescription.dataset.bound = 'true';
      gotodescription.addEventListener('click', function(){
        if (custom__tabs_detail) custom__tabs_detail.click();
        if (custom__tabs_detail) {
          const elementPosition = custom__tabs_detail.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - 160,
            behavior: 'smooth'
          });
        }
      });
    }

    tabs.forEach(function(tab){
      if (tab.dataset.bound) return;
      tab.dataset.bound = 'true';
      tab.addEventListener('click', function(){
        const contentId = this.dataset.contentId;
        const content = document.getElementById(contentId);

        tabContents.forEach(function(c){
          c.classList.remove('active');
        });

        tabs.forEach(function(t){
          t.classList.remove('active');
        });

        this.classList.add('active');
        if (content) {
          content.classList.add('active');
          reloadTrustpilotWidget(content);
        }
      });
    });
  }

  // Mobile Accordion
  if (!window.matchMedia('(min-width: 768px)').matches) {
    const handleCollapse = (heading) => {
      if (heading.classList.contains('block-collapsed')) {
        heading.classList.remove('block-collapsed');
        heading.setAttribute('aria-expanded', 'true');
        reloadTrustpilotWidget(heading.nextElementSibling);
        const elementPosition = heading.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementPosition - 65,
          behavior: 'smooth'
        });
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('aria-expanded', 'false');
      }
    };

    document.querySelectorAll('.custom__tab__heading').forEach((heading, index) => {
      if (heading.dataset.bound) return;
      heading.dataset.bound = 'true';
      if (index === 0) {
        heading.setAttribute('role', 'button');
        heading.setAttribute('aria-expanded', 'true');
        heading.setAttribute('tabindex', '1');
      } else {
        heading.classList.add('block-collapsed');
        heading.setAttribute('role', 'button');
        heading.setAttribute('aria-expanded', 'false');
        heading.setAttribute('tabindex', '1');
      }

      if (heading.nextElementSibling) {
        heading.nextElementSibling.setAttribute('id', `custom__tab-index-${index}`);
        heading.setAttribute('aria-controls', `custom__tab-index-${index}`);
      }

      heading.addEventListener('click', () => { handleCollapse(heading); });
      heading.addEventListener('keypress', () => { handleCollapse(heading); });
    });

    const tpElementMobile = document.getElementById("custom__tabs_trustpilot_mobile");
    const trustpilotMobile = document.getElementById("trustpilot");

    if (trustpilotMobile && !trustpilotMobile.dataset.boundMobile) {
      trustpilotMobile.dataset.boundMobile = 'true';
      trustpilotMobile.addEventListener('click', function(){
        if (tpElementMobile) {
          tpElementMobile.click();
          const elementPosition = tpElementMobile.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - 100,
            behavior: 'smooth'
          });
        }
      });
    }
  }
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', initCustomTabs);
} else {
  initCustomTabs();
}
window.addEventListener('pageshow', initCustomTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
